import api from "./apiClient";

export type SessionPayload = {
  app_id?: string;
  app_secret?: string;
};

export type SessionResponse = {
  token: string;
  expires_at: string;
};

export type ApiEnvelope<T> = {
  code?: number;
  msg?: string;
  data?: T;
  meta_info?: Record<string, unknown>;
};

export type ElevatorUnit = {
  unit_uid: number;
  unit_name?: string;
  unit_type?: string;
  unit_sn?: string;
  [key: string]: unknown;
};

export type ElevatorRealtime = {
  unit_uid: number;
  unit_name?: string;
  current_work_mode?: string;
  current_floor_index?: number;
  current_floor_name?: string;
  current_direction_state?: string;
  current_door_state?: string;
  current_speed?: number;
  is_robot_inside?: boolean;
  online_status?: string;
  cum_door_open_times?: number;
  cum_launch_times?: number;
  cum_move_distance?: number;
  cum_wire_bending_times?: number;
  cum_vibration_frequency?: number;
  timestamp?: number;
  [key: string]: unknown;
};

export type ListElevatorRequest = {
  token: string;
  site_uid?: number;
};

export type RealtimeRequest = {
  token: string;
  site_uid?: number;
  unit_uid_list: number[];
  poll_interval?: number;
};

export type CallRequest = {
  token: string;
  site_uid?: number;
  unit_uid: number;
  floor_index: number;
  floor_type?: string;
  priority?: number;
};

export type OpenDoorRequest = {
  token: string;
  site_uid?: number;
  unit_uid: number;
  floor_index: number;
  duration?: number;
  floor_type?: string;
};

export const createSession = async (
  payload: SessionPayload
): Promise<SessionResponse> => {
  const { data } = await api.post<SessionResponse>("/api/session", payload);
  return data;
};

export const listElevators = async (
  payload: ListElevatorRequest
): Promise<ApiEnvelope<ElevatorUnit[]>> => {
  const { data } = await api.post<ApiEnvelope<ElevatorUnit[]>>(
    "/api/elevators/list",
    payload
  );
  return data;
};

export const fetchRealtime = async (
  payload: RealtimeRequest
): Promise<ApiEnvelope<ElevatorRealtime | ElevatorRealtime[]>> => {
  const { data } = await api.post<ApiEnvelope<ElevatorRealtime | ElevatorRealtime[]>>(
    "/api/elevators/realtime",
    payload
  );
  return data;
};

export const callElevator = async (
  payload: CallRequest
): Promise<ApiEnvelope<Record<string, unknown>>> => {
  const { data } = await api.post<ApiEnvelope<Record<string, unknown>>>(
    "/api/elevators/call",
    payload
  );
  return data;
};

export const openDoor = async (
  payload: OpenDoorRequest
): Promise<ApiEnvelope<Record<string, unknown>>> => {
  const { data } = await api.post<ApiEnvelope<Record<string, unknown>>>(
    "/api/elevators/open-door",
    payload
  );
  return data;
};

export type HistoryEntry = {
  id: string;
  timestamp: string;
  target_url: string;
  method: string;
  status_code: number;
  latency_ms: number;
  request_body?: unknown;
  response_body?: unknown;
  error?: string;
  metadata?: Record<string, unknown>;
};

export const fetchHistory = async (
  limit = 100
): Promise<HistoryEntry[]> => {
  const { data } = await api.get<HistoryEntry[]>("/api/history", {
    params: { limit }
  });
  return data;
};
